import { useEffect, useState } from "react";
import { Grid, Button } from "@mui/material";
import styles from "./styles.module.css";
import InvoiceSample from "../../utils/Invoice/invoiceModel";
import { ReactComponent as UploadIcon } from "../../../images/svg/upload.svg";
import ShopSettingsService from "../../../services/ShopService";
import toast from "react-hot-toast";
import SkeletonLoading from "../../utils/Loading/SkeletonLoading";
import ButtonRed from "../../utils/CustomFields/ButtonRed";
import ButtonGray from "../../utils/CustomFields/ButtonGray";
import * as TerminalHelper from "helpers/TermialHelper";
import ShopsHelper from "helpers/ShopsHelper";

function Invoice() {
  const [loading, setLoading] = useState(false);
  const [selectedTerminal, setSelectedTerminal] = useState("");
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    setLoading(true);

    const currentTerminalId = TerminalHelper.getCurrentTerminalId();
    if (currentTerminalId) {
      setSelectedTerminal(currentTerminalId);
    }

    const shopProfile = ShopsHelper.getCachedShopProfile();
    if (shopProfile?.shop_logo) {
      setImageFile(shopProfile.shop_logo);
    }

    setLoading(false);
  }, []);

  const uploadImage = (image) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onloadend = async () => {
        const logo = {
          image: reader.result,
        };
        await ShopSettingsService.uploadShopLogo(logo);
        resolve();
      };
    });
  };

  const handleUploadLogo = async () => {
    if (!imageFile) {
      toast.error("Please select an image first");
      return;
    }

    setLoading(true);

    try {
      await uploadImage(imageFile);
      setImageFile(null);
    } catch (err) {
      console.error(err);
      toast.error("Failed to upload logo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container className={styles.contentWrapper}>
      <Grid item xs={12} className={styles.contetSection}>
        {/* Terminals Section */}

        <Grid item xs={12} md={12} className={styles.billContent}>
          <Grid className={styles.billSection}>
            {loading ? (
              <SkeletonLoading isOpen={loading} count={1} height={578} xs={12} md={12} sm={12} lg={12} />
            ) : (
              <InvoiceSample terminalId={selectedTerminal} />
            )}
          </Grid>

          {loading ? (
            <SkeletonLoading isOpen={loading} count={1} height={326} xs={12} md={12} sm={12} lg={12} />
          ) : (
            <Grid className={styles.shopLogoSection}>
              <h3 className={styles.shopName}>Shop Logo</h3>
              <Grid>
                <div className={styles.uploadBox}>
                  {imageFile ? (
                    <div style={{ position: "relative", width: 280, height: 155 }}>
                      <img
                        src={typeof imageFile === "string" ? imageFile : URL.createObjectURL(imageFile)}
                        alt="Preview"
                        style={{ width: "100%", height: "100%", borderRadius: 8, objectFit: "contain" }}
                      />
                    </div>
                  ) : (
                    <>
                      <Button className={styles.uploadButton} component="label">
                        <UploadIcon />
                        Upload
                        <input type="file" hidden accept="image/*" onChange={(e) => setImageFile(e.target.files[0])} />
                      </Button>
                      <h3>Choose image or Drop it here</h3>
                      <h4>JPG, JPEG, and PNG (Max size: 5 MB)</h4>
                    </>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} className={styles.buttonContainer}>
                <ButtonGray onClick={() => setImageFile(null)}>Delete</ButtonGray>
                <ButtonRed onClick={handleUploadLogo}>Upload</ButtonRed>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Invoice;
